import React from 'react'
import OpenAccount from '../OpenAccount'
import Stats from './Stats'
import Pricing from './Pricing'
import Education from './Education'
import Awards from './Awards'
import Hero from './Hero'

function HomePage() {
    return (<>
        
        <Hero></Hero>
        <Awards></Awards>
        <Stats></Stats>
        <Pricing></Pricing>
        <Education></Education>
        <OpenAccount></OpenAccount>
        
    </>
    );
}

export default HomePage;